mutation deleteCommentary($leadId: String!, $commentaryId: String!) {
  response: deleteCommentary(leadId: $leadId, commentaryId: $commentaryId)
}
